import "./SupportForm.css";
import Flex from "../Flex/Flex";
import FormItem from "../FormItem/FormItem";
import Text from "../Text/Text";
import Input from "../Input/Input";
import Button from "../Button/Button";
import TextArea from "../TextArea/TextArea";
import SupportIcon from "../../assets/Icons/SupportIcon.svg?react";
import tg from "../../assets/tg.png";
// import skype from "../../assets/skype.png";

import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { sendFeedback } from "../../containers/UserProfilePage/actions";
import { useTranslation } from "react-i18next";

type FormValues = {
  subject: string;
  message: string;
};

const SupportForm = () => {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm<FormValues>({});

  const onSubmit = handleSubmit(({ subject, message }) => {
    dispatch(sendFeedback({ subject, message }));
    reset();
  });

  return (
    <Flex
      className="SupportForm"
      vertical
      gap={0}
    >
      <Flex
        className="SupportForm__Title"
        align="center"
      >
        <i className="SupportForm__TitleIcon">
          <SupportIcon />
        </i>
        <Text
          size={4}
          bold
        >
          {t("support")}
        </Text>
      </Flex>
      <Flex
        showDivider
        gap={24}
      >
        <Flex
          vertical
          gap={24}
        >
          <a
            className="SupportForm__Contact-item"
            href="https://t.me/fishh_support"
            target="blank"
          >
            <img src={tg}></img>
            <Text>Telegram</Text>
          </a>
          {/* <a
            className="SupportForm__Contact-item"
            target="blank"
          >
            <img src={skype}></img>
            <Text>Skype</Text>
          </a> */}
        </Flex>
        <form
          className="SupportForm__Content"
          onSubmit={onSubmit}
        >
          <Text
            size={3}
            className="SupportForm__Description"
          >
            {t("ask_a_question_through_the_feedback_form")}
          </Text>

          <FormItem className="SupportForm__Input">
            <Controller
              name="subject"
              control={control}
              render={({ field }) => (
                <Input
                  placeholder={t("subject_of_the_message")}
                  autoComplete="off"
                  {...field}
                />
              )}
            />
          </FormItem>

          <FormItem error={errors.message?.message}>
            <Controller
              name="message"
              control={control}
              rules={{
                required: t("please_describe_your_problem"),
              }}
              render={({ field }) => (
                <TextArea
                  placeholder={t("describe_the_problem")}
                  autoSize={{ minRows: 5, maxRows: 5 }}
                  aria-invalid={errors.message?.message ? true : false}
                  {...field}
                />
              )}
            />
          </FormItem>

          <FormItem className="SupportForm__Action">
            <Button type="primary">{t("send")}</Button>
          </FormItem>
        </form>
      </Flex>
    </Flex>
  );
};

export default SupportForm;
